import type { PropsWithChildren, ReactNode } from "react"
import React from "react"

import CheckoutFlowHeader from "~components/pages/listing/checkout/checkout-flow/checkout-flow-header"
import CheckoutFlowSummarySidebar from "~components/pages/listing/checkout/checkout-flow/checkout-flow-summary-sidebar"
import CheckoutFlowSummaryDrawer from "~components/pages/listing/checkout/checkout-flow/checkout-flow-summary-drawer"
import {
    CheckoutRootContainer,
    CheckoutLeftContainer,
    CheckoutRightContainer,
} from "~components/pages/listing/checkout/checkout-layout-components"
import { useCheckoutFlow } from "~components/pages/listing/checkout/checkout-flow/checkout-flow-provider"

interface CheckoutContentProps extends PropsWithChildren {
    readonly renderNavButtons: () => ReactNode
    readonly renderHeader?: () => ReactNode
}

export default function CheckoutFlowStep({
    renderNavButtons,
    renderHeader,
    children,
}: CheckoutContentProps) {
    const { isWidget } = useCheckoutFlow()

    return (
        <>
            <CheckoutRootContainer isWidget={isWidget}>
                <CheckoutLeftContainer isWidget={isWidget}>
                    {renderHeader ? renderHeader() : <CheckoutFlowHeader />}
                    {children}
                </CheckoutLeftContainer>
                <CheckoutRightContainer>
                    <CheckoutFlowSummarySidebar
                        renderNavButtons={renderNavButtons}
                    />
                </CheckoutRightContainer>
            </CheckoutRootContainer>
            <CheckoutFlowSummaryDrawer renderNavButtons={renderNavButtons} />
        </>
    )
}
